/*
 * Los textos del sitio.
 *
 * Las palabras viven en contenido.json, que es lo que edita Valentina desde
 * /admin. Aca solo se les da forma y se les suma lo que NO es texto:
 *
 *   - los `id` de la navegacion, que son los anclajes de cada seccion
 *   - la numeracion, que sale del orden
 *
 * Eso queda en codigo a proposito. Son cableado, no redaccion: si se editan
 * por error, un enlace del menu deja de llevar a ninguna parte y no hay nada
 * en pantalla que lo delate.
 *
 * Las lineas de trabajo ya no estan aca: viven enteras en servicios.json,
 * con sus fotos adentro, y se editan como una lista.
 */

import textos from './contenido.json';

const parrafos = (bloque) =>
  bloque
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean);

const lineas = (bloque) =>
  bloque
    .split('\n')
    .map((l) => l.trim())
    .filter(Boolean);

const dosDigitos = (i) => String(i + 1).padStart(2, '0');

export const marca = {
  // En minuscula a proposito: asi se escribe la marca en su propio Instagram.
  nombre: 'emidia',
  bajada: 'florería',
  descripcion: 'Diseño floral',
  lugar: 'Santiago, Región Metropolitana',
};

export const contacto = {
  instagram: textos.contacto.instagram,
  instagramUrl: `https://www.instagram.com/${textos.contacto.instagram}/`,
  correo: textos.contacto.correo,
  horario: lineas(textos.contacto.horario),
};

export const apertura = textos.apertura;

export const introServicios = textos.introServicios;

export const proceso = {
  ...textos.proceso,
  pasos: textos.proceso.pasos.map((paso, i) => ({ numero: dosDigitos(i), ...paso })),
};

export const sobre = {
  titulo: textos.sobre.titulo,
  parrafos: parrafos(textos.sobre.parrafos),
};

export const datos = textos.datos;

export const cierre = textos.cierre;

/*
 * Preguntas frecuentes. Ademas de servir a quien lee, son las consultas que la
 * gente escribe en Google. El bloque FAQPage del HTML se genera desde aca en
 * cada build (scripts/sincroniza-faq.js), asi que no hay dos copias que
 * mantener: lo que ella escribe es lo que lee Google.
 */
export const preguntas = textos.preguntas;

/* Los id son los anclajes de cada seccion: tampoco se editan desde el panel. */
const ORDEN_NAV = ['servicios', 'galeria', 'proceso', 'sobre', 'preguntas', 'contacto'];

export const navegacion = ORDEN_NAV.map((id) => ({ id, etiqueta: textos.navegacion[id] }));
